import React from "react";

export const Head = ({ titleSuffix }) => {
	return (
		<>
			<title>{`Witz | ${titleSuffix || "#1 Witty Chat Wingman"}`}</title>
			<meta property='og:image' content='/og_image.svg' />
			<meta
				property='og:title'
				content={`Witz | ${titleSuffix || "#1 Witty Chat Wingman"}`}
			/>
			<meta
				property='og:desciprtion'
				content='Witz - Boost your rizz with Witz, your AI Dating and Relationship Assistant.'
			/>
			<meta
				name='desciprtion'
				content='Witz - Boost your rizz with Witz, your AI Dating and Relationship Assistant.'
			/>
		</>
	);
};
